import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_USER_BY_ID } from "./actionTypes"
import { getUserByIdSuccess, getUserByIdFail } from "./action"

//Include Both Helper File with needed methods
import { getUserById } from "helpers/backend_helper"

function* fetchUser({ payload: id }) {
  try {
    const response = yield call(getUserById, id)
    yield put(getUserByIdSuccess(response.user))
  } catch (error) {
    yield put(getUserByIdFail(error))
  }
}

function* GetUserByIdSaga() {
  yield takeEvery(GET_USER_BY_ID, fetchUser)
}

export default GetUserByIdSaga
